<template>
  <div>
    <v-text-field
      :label="label('address')"
      :value="value.address"
      :name="prefix + 'Address'"
      :rules="rules.address"
      @input="updateModel('address', $event)"
    ></v-text-field>

    <v-container>
      <v-layout row wrap>
        <v-flex xs4>
          <v-text-field
            :label="label('postalCode')"
            :value="value.postalCode"
            :name="prefix + 'PostalCode'"
            :rules="rules.postalCode"
            @input="updateModel('postalCode', $event)"
          ></v-text-field>
        </v-flex>
        <v-flex xs8>
          <v-text-field
            :label="label('city')"
            :value="value.city"
            :name="prefix + 'City'"
            :rules="rules.city"
            @input="updateModel('city', $event)"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
export default {
  name: 'AddressFields',
  props: {
    value: {
      type: Object,
      default: () => ({
        address: '',
        postalCode: '',
        city: ''
      })
    },
    prefix: {
      type: String,
      default: ''
    },
    mandatory: {
      type: Array,
      default: () => ([])
    },
    rules: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    label (key) {
      const s = this.$vuetify.lang.t('$vuetify.crm.contact.address.' + key)
      return this.mandatory.includes(key) ? (s + ' *') : s
    },
    updateModel (prop, value) {
      this.$emit('input', { ...this.value, [prop]: value })
    }
  }
}
</script>
